import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { iVendorProductsState, iVendorProductDTO } from "./Types";
import { getVendorProductsList } from "./ThunkActions";

const initialState: iVendorProductsState = {
  vendorProductsList: null,
  isLoading: false,
  errorMessage: null,
};

const vendorProductsSlice = createSlice({
  name: "vendorProducts",
  initialState,
  reducers: {
    resetVendorProductsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVendorProductsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVendorProductsList.fulfilled, (state, action) => {
              const payload = action.payload;
              if (payload && payload.data) {
                state.vendorProductsList = payload.data.data;
                state.isLoading = false;
              }
            })
      .addCase(getVendorProductsList.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message || "Failed to fetch products";
      });
  },
});

export const { resetVendorProductsState } = vendorProductsSlice.actions;
export default vendorProductsSlice.reducer;
